"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoDatesService = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var PromoDatesService = (function () {
    function PromoDatesService() {
    }
    PromoDatesService.convertAdCampaignsToPromoDates = function (adCampaigns, startTime, timezone) {
        if (timezone === void 0) { timezone = moment_timezone_1.default.tz.guess(); }
        return adCampaigns.reduce(function (sum, campaign) {
            campaign.promoad.forEach(function (promo) {
                var mediafileData = campaign.promos.find(function (p) { return p.id === promo.promoId; });
                if (!mediafileData)
                    return;
                sum.push({
                    id: promo.id,
                    date: startTime
                        .clone()
                        .set({
                        hours: promo.time.h,
                        minutes: promo.time.m,
                        seconds: 0,
                    })
                        .tz(timezone, true),
                    days: campaign.days,
                    startCompany: campaign.startCompany
                        ? (0, moment_timezone_1.default)(campaign.startCompany).utc(false).tz(timezone)
                        : undefined,
                    endCompany: campaign.endCompany
                        ? (0, moment_timezone_1.default)(campaign.endCompany).utc(false).tz(timezone)
                        : undefined,
                    startDayTime: campaign.startDayTime,
                    endDayTime: campaign.endDayTime,
                    adcampaignId: campaign.id,
                    promoId: promo.promoId,
                    mediafileData: mediafileData,
                });
            });
            return sum;
        }, []);
    };
    PromoDatesService.sortAndCorrectPromoDates = function (promoDates, startTime) {
        promoDates.sort(function (a, b) {
            if (a.date.isSame(b.date)) {
                return a.promoId > b.promoId ? 1 : -1;
            }
            return a.date > b.date ? 1 : -1;
        });
        var sliceIndex = promoDates.findIndex(function (promoDate) { return promoDate.date.format("HH:mm:ss") >= (0, moment_timezone_1.default)(startTime).format("HH:mm:ss"); });
        if (sliceIndex === -1)
            sliceIndex = promoDates.length;
        var slicedPromoDates = promoDates.slice(0, sliceIndex).map(function (promoDate) { return (__assign(__assign({}, promoDate), { date: promoDate.date.clone().add(1, "day") })); });
        promoDates.push.apply(promoDates, __spreadArray([], __read(slicedPromoDates), false));
        return promoDates;
    };
    return PromoDatesService;
}());
exports.PromoDatesService = PromoDatesService;
//# sourceMappingURL=PromoDatesService.js.map